/**
 * MeubelBaas Cart Drawer — Upsells + Free Shipping Bar
 * Laadt na cart-drawer.js (defer)
 *
 * Verantwoordelijkheden:
 * 1. Free shipping bar dynamisch updaten bij cart wijzigingen
 * 2. Upsells laden (server-side fallback → Recommendations API)
 * 3. Upsell "Toevoegen" add-to-cart handling
 */

/* ══════════════════════════════════════════════════════════
   0. GLOBALE ADD-TO-CART HELPER
   Gebruik: window.mbmAddToCart(variantId, quantity)
   Voegt toe aan cart EN opent de drawer automatisch.
   Retourneert een Promise zodat callers UI feedback kunnen geven.
   ══════════════════════════════════════════════════════════ */

window.mbmAddToCart = function (variantId, quantity) {
  quantity = quantity || 1;
  var cartDrawer = document.querySelector('cart-drawer');

  var formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', String(quantity));

  if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
    var sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
    formData.append('sections', sections.join(','));
    formData.append('sections_url', window.location.pathname);
  }

  var config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  delete config.headers['Content-Type'];
  config.body = formData;

  return fetch(routes.cart_add_url, config)
    .then(function (r) { return r.json(); })
    .then(function (response) {
      if (response.status) {
        // Error van Shopify (bv. uitverkocht)
        throw new Error(response.description || response.message || 'Fout bij toevoegen');
      }

      // Open drawer met nieuwe inhoud
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(response);
      }

      // Publiceer cart update event
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'mbm-add-to-cart',
          productVariantId: variantId,
          cartData: response
        });
      }

      return response;
    });
};


(function () {
  'use strict';

  /* ══════════════════════════════════════════════════════════
     1. FREE SHIPPING BAR
     ══════════════════════════════════════════════════════════ */

  function updateShippingBar(cartTotal) {
    var bar = document.querySelector('.mbm-shipping-bar');
    if (!bar) return;

    var threshold = parseInt(bar.dataset.threshold, 10);
    if (!threshold || threshold <= 0) return;

    var remaining = Math.max(0, threshold - cartTotal);
    var pct = Math.min(100, (cartTotal / threshold) * 100);

    var fill = bar.querySelector('.mbm-shipping-bar__fill');
    var textEl = bar.querySelector('.mbm-shipping-bar__text');

    if (fill) {
      fill.style.width = pct + '%';
      if (remaining <= 0) {
        fill.classList.add('mbm-shipping-bar__fill--complete');
      } else {
        fill.classList.remove('mbm-shipping-bar__fill--complete');
      }
    }

    var iconEl = bar.querySelector('.mbm-shipping-bar__icon');
    if (textEl) {
      if (remaining > 0) {
        var formatted = formatMoney(remaining);
        textEl.innerHTML = 'Besteed nog <strong>' + formatted + '</strong> voor gratis verzending';
        textEl.classList.remove('mbm-shipping-bar__text--complete');
        if (iconEl) iconEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>';
      } else {
        textEl.innerHTML = 'Je hebt gratis verzending!';
        textEl.classList.add('mbm-shipping-bar__text--complete');
        if (iconEl) iconEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>';
      }
    }
  }

  /**
   * Format cents to Euro string (NL locale)
   * 20000 → "€ 200,00" / 1995 → "€ 19,95"
   */
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '€\u00A0' + amount;
  }


  /* ══════════════════════════════════════════════════════════
     2. UPSELLS — LADEN
     ══════════════════════════════════════════════════════════ */

  /**
   * Laadt upsells via Shopify Product Recommendations API
   * @param {string|number} productId - Product ID om aanbevelingen voor op te halen
   */
  function loadUpsells(productId) {
    /* Check of upsells enabled zijn via data-attribute */
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && drawerEl.dataset.upsellsEnabled === 'false') return;

    var container = document.getElementById('CartDrawer-Upsells');
    var grid = document.getElementById('CartDrawer-UpsellsGrid');
    if (!container || !grid) return;

    // Als server-side content al geladen is voor dit product, skip
    if (grid.children.length > 0 && container.dataset.lastProductId == productId) {
      return;
    }

    // Haal cart product IDs op om duplicaten te filteren
    var cartProductIds = getCartProductIds();

    // Fetch complementary products
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=complementary')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          // Fallback naar related
          return fetch('/recommendations/products.json?product_id=' + productId + '&limit=6&intent=related')
            .then(function (r) { return r.json(); });
        }
        return data;
      })
      .then(function (data) {
        if (!data.products || data.products.length === 0) {
          container.style.display = 'none';
          return;
        }

        // Filter producten die al in de cart zitten
        var filtered = data.products.filter(function (p) {
          return cartProductIds.indexOf(String(p.id)) === -1;
        });

        if (filtered.length === 0) {
          container.style.display = 'none';
          return;
        }

        container.style.display = '';
        container.dataset.lastProductId = productId;

        grid.innerHTML = filtered.slice(0, 3).map(function (product) {
          var variant = product.variants[0];
          var price = formatMoney(variant.price);
          var compareHtml = '';

          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareHtml = '<s class="mbm-upsell-card__price-old">' + formatMoney(variant.compare_at_price) + '</s>';
          }

          var imgSrc = product.featured_image
            ? getSizedImageUrl(product.featured_image, '200x')
            : '';

          return '<div class="mbm-upsell-card" data-variant-id="' + variant.id + '" data-product-id="' + product.id + '">' +
            '<a href="' + product.url + '" class="mbm-upsell-card__image" tabindex="-1" aria-hidden="true">' +
              (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="100">' : '') +
            '</a>' +
            '<div class="mbm-upsell-card__info">' +
              '<a href="' + product.url + '" class="mbm-upsell-card__title" tabindex="-1">' + truncate(product.title, 40) + '</a>' +
              '<span class="mbm-upsell-card__price">' + compareHtml + price + '</span>' +
            '</div>' +
            '<button type="button" class="mbm-upsell-add" data-variant-id="' + variant.id + '" aria-label="' + escapeHtml(product.title) + ' toevoegen aan winkelwagen">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>' +
              '<span>Toevoegen</span>' +
            '</button>' +
          '</div>';
        }).join('');
      })
      .catch(function (err) {
        console.warn('MBM Cart Upsells: kon aanbevelingen niet laden', err);
        container.style.display = 'none';
      });
  }

  /**
   * Haal alle product IDs op die momenteel in de cart zitten
   */
  function getCartProductIds() {
    var ids = [];
    document.querySelectorAll('.mbm-cart-item[data-product-id]').forEach(function (el) {
      ids.push(el.dataset.productId);
    });
    // Fallback: ook data-product-id van upsell container lezen
    var container = document.getElementById('CartDrawer-Upsells');
    if (container && container.dataset.lastProductId) {
      // niet nodig om toe te voegen, deze is het bronproduct
    }
    return ids;
  }


  /* ══════════════════════════════════════════════════════════
     3. UPSELL — ADD TO CART
     ══════════════════════════════════════════════════════════ */

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mbm-upsell-add');
    if (!btn) return;

    e.preventDefault();
    btn.disabled = true;
    var btnSpan = btn.querySelector('span');
    var originalText = btnSpan ? btnSpan.textContent : '';
    if (btnSpan) btnSpan.textContent = 'Toevoegen...';

    var variantId = btn.dataset.variantId;
    var cartDrawer = document.querySelector('cart-drawer');

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      var sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      formData.append('sections', sections.join(','));
      formData.append('sections_url', window.location.pathname);
    }

    var config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    fetch(routes.cart_add_url, config)
      .then(function (r) { return r.json(); })
      .then(function (response) {
        if (response.status) {
          // Error
          if (btnSpan) btnSpan.textContent = 'Fout';
          setTimeout(function () {
            if (btnSpan) btnSpan.textContent = originalText;
            btn.disabled = false;
          }, 2000);
          return;
        }

        // Success — re-render drawer
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(response);
        }

        // Publish cart update event
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'mbm-cart-upsell',
            cartData: response
          });
        }
      })
      .catch(function () {
        if (btnSpan) btnSpan.textContent = 'Fout';
        setTimeout(function () {
          if (btnSpan) btnSpan.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      });
  });


  /* ══════════════════════════════════════════════════════════
     4. EVENT SUBSCRIPTIONS
     ══════════════════════════════════════════════════════════ */

  // Subscribe to cart updates + update shipping bar na elke drawer open/re-render
  function refreshShippingBar() {
    fetch(routes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateShippingBar(cart.total_price || 0);
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // Update shipping bar — delay zodat DOM re-render klaar is
      setTimeout(refreshShippingBar, 500);

      // Herlaad upsells
      var cartData = event.cartData;
      if (cartData && cartData.items && cartData.items.length > 0) {
        var lastItem = cartData.items[cartData.items.length - 1];
        if (lastItem && lastItem.product_id) {
          setTimeout(function () { loadUpsells(lastItem.product_id); }, 300);
        }
      }
    });
  }


  /* ══════════════════════════════════════════════════════════
     5. INITIALISATIE — Lazy load bij eerste drawer open
     ══════════════════════════════════════════════════════════ */

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (drawer.classList.contains('active')) {
          // Update shipping bar bij elke drawer open
          refreshShippingBar();

          if (drawer.dataset.upsellsEnabled === 'false') break;
          var container = document.getElementById('CartDrawer-Upsells');
          if (container && container.dataset.lastProductId) {
            var grid = document.getElementById('CartDrawer-UpsellsGrid');
            if (grid && grid.children.length === 0) {
              loadUpsells(container.dataset.lastProductId);
            }
          }
          break;
        }
      }
    });

    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }


  /* ══════════════════════════════════════════════════════════
     HELPERS
     ══════════════════════════════════════════════════════════ */

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function truncate(str, len) {
    if (!str) return '';
    return str.length > len ? str.substring(0, len) + '...' : str;
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    // Shopify image URL sizing: insert _SIZEx before extension
    return url.replace(/(\.[^.]+)$/, '_' + size + '$1');
  }

})();
